/**
 * @generated SignedSource<<0d8d8060908a94fc709a2e161f2a40cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorecastPickerPopoverDashboards$data = ReadonlyArray<{
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"StorecastPickerPopoverItem_dashboard">;
  readonly " $fragmentType": "StorecastPickerPopoverDashboards";
}>;
export type StorecastPickerPopoverDashboards$key = ReadonlyArray<{
  readonly " $data"?: StorecastPickerPopoverDashboards$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorecastPickerPopoverDashboards">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "StorecastPickerPopoverDashboards",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorecastPickerPopoverItem_dashboard"
    }
  ],
  "type": "Dashboard",
  "abstractKey": null
};

(node as any).hash = "fb72760658b099ad38dd271d473e6d47";

export default node;
